__turbopack_context__.v({
  "code": "RasputinText-module-scss-module__byqbIG__code",
  "muted": "RasputinText-module-scss-module__byqbIG__muted",
});
